import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Helpers } from "src/helpers/helpers";
import { BaseService } from "./base.service";
import { ICountService } from "./icount.service";
import { CareplusPolicy } from "src/models/careplus-policy";
import { FeeDetails } from "src/models/fee-details";
import { IssuePolicy } from "src/models/issue-policy";

@Injectable({
  providedIn: "root",
})
export class CareplusRequestsService
  extends BaseService
  implements ICountService
{
  private pathAPI = environment.apiUrl;

  constructor(private http: HttpClient, helper: Helpers) {
    super(helper);
  }

  getData(body: any): Observable<CareplusPolicy[]> {
    return this.http.post<CareplusPolicy[]>(
      this.pathAPI + "careplus/policy/requests",
      body,
      super.header()
    );
  }

  getCount(body: any) {
    return this.http
      .post<any>(
        this.pathAPI + "careplus/policy/requests/count",
        body,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  getFeeDetails(): Observable<FeeDetails> {
    return this.http.get<FeeDetails>(
      this.pathAPI + "careplus/fee",
      super.header()
    );
  }

  issuePolicy(requestId: number, body: IssuePolicy) {
    return this.http.post(
      `${this.pathAPI}careplus/policy/requests/${requestId}/issue-policy`,
      body,
      super.header()
    );
  }

  resendEmail(requestId: number) {
    return this.http.post(
      `${this.pathAPI}careplus/policy/requests/${requestId}/resend-email`,
      {},
      super.header()
    );
  }

  generateDocuments(requestId: number) {
    return this.http.post(
      `${this.pathAPI}careplus/policy/requests/${requestId}/generate-documents`,
      {},
      super.header()
    );
  }
}
